import React, { useState, useEffect } from "react";
import styles from "./css/index.module.css";

import speakersData from "./data/index.json";
import Modal from "./modal";

import { useParams } from "react-router-dom";
import SpeakerCard from "../../components/speakerCard";

const Speakers = () => {
    const { domain } = useParams();

    const [data, setData] = useState(speakersData);
    const [modalData, seModalData] = useState({});
    const [isModelOpen, setModelModelOpen] = useState(false);
    useEffect(() => {
        setDropDownDefaultState();
        // console.log(domain, "Domain");
    }, [domain]);

    const [selectedDomain, setSelectedDomain] = useState("Select Domain");

    const setDropDownDefaultState = () => {
        switch (domain) {
            case "post-quantum-cryptography":
                setSelectedDomain("Post-Quantum Cryptography");
                filterProgram("Post-Quantum Cryptography");
                break;
            case "advanced-persistent-threats":
                setSelectedDomain("Advanced Persistent Threat");
                filterProgram("Advanced Persistent Threat");
                break;
            case "supply-chain-security":
                setSelectedDomain("Supply Chain Security");
                filterProgram("Supply Chain Security");
                break;
            case "electronic-warfare":
                setSelectedDomain("Electronic Warfare");
                filterProgram("Electronic Warfare");
                break;
            default:
                setSelectedDomain("Select Domain");
                filterProgram("Select Domain");
                break;
        }
    };

    const filterProgram = async (name) => {
        setSelectedDomain(name);
        setData(() => {
            if (name === "Select Domain") {
                return speakersData;
            }
            let data = [];
            speakersData.map((item) => {
                if (item.name === name) {
                    data.push({
                        name: item.name,
                        data: item.data.filter((item) => !item.isNotShowInDomain),
                    });
                }
            });
            return data;
        });
    };

    return (
        <section className={styles.containerWrapper}>
            <div className={styles.heroSection}>
                <div className={styles.containerTitle}>
                    MEET OUR <span className={styles.highlight}>SPEAKERS</span>{" "}
                </div>
                <div className={styles.containerSubTitle}>Hear about the latest cybersecurity trends and techniques presented by world-class speakers from industry and academia!</div>
            </div>

            <div className={styles.containerBody}>
                <div className={styles.containerSearchContentBodyItem}>
                    <select value={selectedDomain} className={styles.containerSearchContentDropdown} onChange={(e) => filterProgram(e?.target?.value)}>
                        <option value="Select Domain">All</option>
                        <option value="Electronic Warfare">Electronic Warfare</option>
                        <option value="Post-Quantum Cryptography">Post-Quantum Cryptography</option>
                        <option value="Supply Chain Security">Supply Chain Security</option>
                        <option value="Advanced Persistent Threat">Advanced Persistent Threat</option>
                    </select>
                </div>
                <div className={styles.grid}>
                    {data
                        .flatMap((domains) =>
                            domains.data.map((item) => ({
                                ...item,
                                domainName: domains.name, // Add the domain name to each speaker item
                            }))
                        )
                        .map((item, index) => (
                            <SpeakerCard key={item.name} keyValue={index} program={item} seModalData={seModalData} setModelModelOpen={setModelModelOpen} />
                            // <div key={index} className={styles.grid_item}>
                            //     <div className={styles.left}>
                            //         <img src={`${require(`./speakersPhoto/${item.image}`)}`} alt={item.name} />
                            //     </div>
                            //     <div className={styles.right}>
                            //         <h2>{item.name}</h2>
                            //         <h3>{item.title}</h3>
                            //         <p>{item.description}</p>
                            //         <ul>
                            //             <li>
                            //                 <span>Affiliation:</span> {item.affiliation}
                            //             </li>
                            //             <li>
                            //                 <span>Domain:</span> {item.domainName} {/* Use the correct domain name */}
                            //             </li>
                            //         </ul>

                            //         <div className={styles.social_links}>
                            //             <a
                            //                 className={styles.linkdinIcon}
                            //                 href="https://www.linkedin.com/company/c3i-hub/"
                            //                 rel="noopener noreferrer"
                            //                 target="_blank"
                            //                 style={{ color: "rgb(0, 119, 181)" }}
                            //             >
                            //                 <svg
                            //                     width={"1.5rem"}
                            //                     aria-hidden="true"
                            //                     focusable="false"
                            //                     data-prefix="fab"
                            //                     data-icon="linkedin"
                            //                     role="img"
                            //                     xmlns="http://www.w3.org/2000/svg"
                            //                     viewBox="0 0 448 512"
                            //                 >
                            //                     <path
                            //                         fill="currentColor"
                            //                         d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                            //                     ></path>
                            //                 </svg>
                            //             </a>
                            //             <button
                            //             className={styles.moreInfoButton}
                            //                 onClick={() => {
                            //                     seModalData(item);
                            //                     setModelModelOpen(true);
                            //                 }}
                            //             >
                            //                 More Info
                            //             </button>
                            //         </div>
                            //     </div>
                            //     {item.speakerType && <p className={styles.keynote}>{item.speakerType}</p>}
                            // </div>
                        ))}
                </div>
            </div>

            {isModelOpen && <Modal data={modalData} onClose={() => setModelModelOpen(false)} />}
        </section>
    );
};

export default Speakers;
